import employability from '../assets/images/resources/employability.png';
import learning from '../assets/images/resources/learning.png';
import communication from '../assets/images/resources/communication.png';
import development from '../assets/images/resources/personalDev.png';
import activeCitizenship from '../assets/images/resources/activeCitizenship.png';
import internship from '../assets/images/resources/intership.png';
import entrepreneurship from '../assets/images/resources/enterpreuneurship.png';

export const getResourceCoverImageUrl = (name: string) => {
  const resourceName = name.toLowerCase();

  switch (true) {
    case resourceName.includes('employability'):
      return employability.src;
    case resourceName.includes('learning'):
      return learning.src;
    case resourceName.includes('communication'):
      return communication.src;
    case resourceName.includes('personal development'):
      return development.src;
    case resourceName.includes('active citizenship'):
      return activeCitizenship.src;
    case resourceName.includes('internship'):
      return internship.src;
    case resourceName.includes('entrepreneurship'):
      return entrepreneurship.src;
  }
};
